import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import { genres } from "@/mocks/shows";

export default function Categories() {
  const [keyword, setKeyword] = useState("");

  const list = useMemo(() => {
    const key = keyword.trim();
    if (!key) return genres;
    return genres.filter(
      (genre) => genre.name.includes(key) || genre.desc.includes(key)
    );
  }, [keyword]);

  return (
    <section id="category" className="scroll-mt-24 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="分类浏览"
            title="按题材找到你更熟悉的那种故事"
            description="不同题材的叙事节奏差别很大。先确定题材方向，再去热播推荐里挑具体剧集，通常比漫无目的地翻列表更省时间。"
          />
          <div className="reveal w-full max-w-sm">
            <label className="flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 focus-within:border-primary-400">
              <i className="ri-search-line text-base text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索题材，如 悬疑 / 古装"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
              {keyword ? (
                <button
                  type="button"
                  aria-label="清除搜索"
                  onClick={() => setKeyword("")}
                  className="text-foreground-400 transition-colors hover:text-foreground-700"
                >
                  <i className="ri-close-circle-line text-base"></i>
                </button>
              ) : null}
            </label>
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {list.map((genre) => (
            <article
              key={genre.id}
              className="reveal flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${genre.icon} text-xl`}></i>
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-[11px] font-semibold text-accent-800">
                  {genre.count} 部
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {genre.name}
              </h3>
              <p className="mt-1.5 text-xs leading-6 text-foreground-500">{genre.desc}</p>
            </article>
          ))}
        </div>

        {list.length === 0 ? (
          <p className="mt-9 rounded-lg border border-background-200 bg-background-50 p-6 text-center text-sm text-foreground-500">
            没有匹配「{keyword}」的题材，试试「悬疑」「古装」或「都市」。
          </p>
        ) : null}
      </div>
    </section>
  );
}